import script from "./AdditionalServiceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalServiceInfo.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalServiceInfo.vue?vue&type=style&index=0&id=5e32f97a&lang=scss"

const __exports__ = script;

export default __exports__